export default __webpack_public_path__ + "static/media/HPEdited.40e35996.webp";